import { Convergence } from "@tracker-bet-analystic/domain";

interface ConvergenceTableProps {
  convergence: Convergence[];
}

const levelLabels: Record<Convergence["level"], { label: string; className: string }> = {
  high: { label: "Alta", className: "badge-success" },
  moderate: { label: "Moderada", className: "badge-warning" },
  low: { label: "Baixa/Divergente", className: "badge-neutral" },
};

export function ConvergenceTable({ convergence }: ConvergenceTableProps) {
  if (convergence.length === 0) {
    return (
      <div className="card p-6">
        <p className="text-[var(--color-text-muted)]">
          Nenhuma convergência classificada — recortes não atendem critérios de elegibilidade
          (mínimo 10 selecionados e 8 válidos em ambos os lados).
        </p>
      </div>
    );
  }

  return (
    <div className="card overflow-hidden">
      <div className="table-container">
        <table className="table" role="table">
          <thead>
            <tr>
              <th scope="col">Linha</th>
              <th scope="col">Frequência Mandante (casa)</th>
              <th scope="col">Frequência Visitante (fora)</th>
              <th scope="col">Nível</th>
              <th scope="col">Amostra Mandante</th>
              <th scope="col">Amostra Visitante</th>
            </tr>
          </thead>
          <tbody>
            {convergence.map((c, i) => {
              const { label, className } = levelLabels[c.level];
              return (
                <tr key={i}>
                  <td className="font-mono font-medium">Over {c.marketKey.line}</td>
                  <td>{(c.homeFrequency * 100).toFixed(1)}%</td>
                  <td>{(c.awayFrequency * 100).toFixed(1)}%</td>
                  <td><span className={className}>{label}</span></td>
                  <td className="font-mono text-sm">{c.homeSample.valid}/{c.homeSample.selected}</td>
                  <td className="font-mono text-sm">{c.awaySample.valid}/{c.awaySample.selected}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="p-4 text-sm text-[var(--color-text-muted)] border-t border-[var(--color-border)]">
        <p>Critério: ambos recortes elegíveis (selecionados ≥10, válidos ≥8). Alta: ambos ≥70% e diferença ≤20pp. Moderada: ambos ≥60%.</p>
      </div>
    </div>
  );
}